/**
 * Build a url combining passed in tokens.
 * Makes sure only one slash is used between each token
 *
 *  ex:  <Link to={createLink(match.url, '/create/scorm')}>
 *
 * @param tokens
 * @returns {string}
 */
export const createLink = (...tokens) => {
  return '/' + tokens.map((token) => token.replace(/^\//, '').replace(/\/$/, '')).join('/')
}



// WEBPACK FOOTER //
// ./src/utils/links.js